export default "__VITE_ASSET__BJZh6fdb__"